import { logError } from '@/common/utils/sharedUtils';
import { BfwUserContextService, UserInfoV2 } from 'generatedBfw/static';

export const UserInfoUrl = `/elysium-api/user/v2/info`;

export const DefaultUnknownUser: UserInfoV2 = {
  isUserLoggedIn: false,
  isAdmin: false,
  subscriptionActive: false,
  shouldMarketingConsentsShow: false,
  isEuropean: false,
};

export const fetchUserInfo = async (): Promise<UserInfoV2> => {
  try {
    return await BfwUserContextService.getUserInfoV2();
  } catch {
    logError('Failed to fetch user info, using default anonymous user');
    return DefaultUnknownUser;
  }
};
